export default function () {
  return {
    list: [],
    current: {
      createdAt: '',
      method: '',
      searchConfig: '',
      result: {},
      status: '',
      system: {},
      organization: {}
    },
    manual_scans: []
  }
}
